import SubHeadingwithback from './SubHeadingwithback';
export default SubHeadingwithback;
